import React from 'react';
import {DataSharingRuleContainer} from '../../Containers/PermissionControlsContainer';


const DataSharingRule = (props) => {
	return (
		<DataSharingRuleContainer action="show" show=""/>
	);
}

export default DataSharingRule;